import { Grid, Paper } from "@material-ui/core";
import * as React from "react";
import { SelectInput } from "react-admin";
import { FileGrid } from "../../../../Components/FileGrid";
import { Separator } from "../../../../Components/Separator";
import { UploadFile } from "../../../../Components/UploadFile";
import {
  GetRequestFileType,
  GetRequestUnserviceableFileType,
  RequestFileType,
} from "../../../../Enums/RequestFileType";
import { RequestOrderTabEnum } from "../../../../Enums/RequestOrderTabEnum";
import { RequestStatus } from "../../../../Enums/RequestStatus";
import { SectionTitle } from "../../../../Components/SectionTitle";
import "./RbhRequestOrderEdit.css";

export default function RbhRequestFiles(props) {
  return (
    <div>
      {props?.isAttachmentVisible?.() && (
        <Paper>
          <hr />
          <Grid item>
            <hr />
            <SectionTitle label="ATTACHMENTS" align="Center" color="Primary" />
            <hr />

            {props?.canRemove && (
              <>
                <SelectInput
                  source="fileType"
                  inputProps={{
                    value:
                      props?.selectedRequestOrderFileType ||
                      (props?.activeTab === props?.getTabEnumValue(RequestOrderTabEnum.UnServiceableTab)
                        ? RequestFileType.ShippingInvoice
                        : props?.requestDetail?.requestStatus === Number(RequestStatus.NotPool)
                          ? RequestFileType.AarScopeInvestigation
                          : RequestFileType.AarProvideNecessary),
                  }}
                  choices={
                    props?.activeTab === props?.getTabEnumValue(RequestOrderTabEnum.UnServiceableTab)
                      ? GetRequestUnserviceableFileType(props?.requestDetail?.requestStatus as RequestStatus)
                      : GetRequestFileType
                  }
                  optionText="Description"
                  optionValue="Value"
                  fullWidth
                  required
                  variant="outlined"
                  onChange={props?.changeRequestOrderFileType}
                />

                <UploadFile
                  label=""
                  multiple={false}
                  onHandleFileExecute={() =>
                    props?.onHandleFileExecute().then(() => {
                      props?.getRequestDetail();
                    })
                  }
                  source="requestorderfilerelations"
                  object={{
                    requestOrderId: props?.requestId,
                    requestFileTypeGroupEnum:
                      props?.activeTab === props?.getTabEnumValue(RequestOrderTabEnum.InfoTab)
                        ? RequestFileType.Info
                        : props?.activeTab === props?.getTabEnumValue(RequestOrderTabEnum.ServiceableTab)
                          ? RequestFileType.Serviceable
                          : RequestFileType.Unserviceable,
                    requestFileTypeEnum: props?.selectedRequestOrderFileType,
                  }}
                />
              </>
            )}
            <Separator />
            <FileGrid
              source="requestorderfilerelations"
              filter={{
                requestOrderId__eq: props?.requestId.toString(),
                requestFileTypeGroupEnum__eq:
                  props?.activeTab === props?.getTabEnumValue(RequestOrderTabEnum.InfoTab)
                    ? RequestFileType.Info
                    : props?.activeTab === props?.getTabEnumValue(RequestOrderTabEnum.ServiceableTab)
                      ? RequestFileType.Serviceable
                      : RequestFileType.Unserviceable,
              }}
              trigged={props?.getFileGrid}
              canRemove={props?.canRemove}
              showFileType={true}
              triggeted={() => props?.onFileGridRefresh()} // BHA Special :)
            />
          </Grid>
        </Paper>
      )}
    </div>
  );
}
